import router from '@/router'
import { v4 as uuidv4 } from 'uuid'
import NotificationService from '@/modules/notifications/services/notifications-service'
import axios from '@/plugins/axios'

const registerVuexModule = (rootStore, moduleName, store) => {
  if (!(moduleName in rootStore._modules.root._children)) {
    rootStore.registerModule(moduleName, store)
  }
}

// Get the error response and create the error array
const parseErrorResponseToArray = error => {
  let data
  if (error.response && error.response.data && error.response.data.errors) {
    data = error.response.data.errors
  } else if (error.errors) {
    data = error.errors
  } else {
    data = ['Houve um problema ao processar a requisição, tente novamente mais tarde']
  }
  return data
}

// Check to see if user is owner of entity and redirect if it isnt
const checkIfUserIsOwnerOfEntity = (entity, user) => {
  if (entity.user.id !== user.id) {
    const notification = {
      notification: {
        type: 'error',
        content: 'Você não tem acesso a essa entidade'
      }
    }
    NotificationService.createGlobalSuccessNotification(notification)
    return router.push('/')
  }
}

const checkIfUserCanPublishOnGroup = (entity, user) => {
  if (entity.is_public_posting_enabled && entity.is_member) return true

  return checkIfUserIsOwnerOfEntity(entity, user)
}

// Create unique id
const createUniqueId = () => {
  return uuidv4()
}

/**
 * Get zicpode data
 * @param {*} zipcode
 */
const getCEPData = async zipcode => {
  if (zipcode.length <= 0) return false
  try {
    const response = await axios.get('addresses/zipcode', {
      params: {
        zipcode: zipcode
      }
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get the youtube video ID given the link
 * @param {*} src
 */
const getYoutubeSrcIDFromLink = src => {
  return src.replace('https://www.youtube.com/watch?v=', '').replace('https://youtu.be/', '').replace('http://www.youtube.com/watch?v=', '').replace('http://youtu.be/', '')
}

/**
 * Resolve post URL
 */
const resolvePostUrl = (post) => {
  const route = {}
  if (post) {
    if (post.type === 'chapter') {
      route.name = 'chapters.show'
      route.params = { username: post.user.username, bookSlug: post.book.slug, slug: post.slug }
    } else {
      route.name = 'posts.show'
      route.params = { username: post.user.username, slug: post.slug }
    }
    const props = router.resolve(route)
    return props.href
  }
  return '/'
}

// Create clear slug
const slugify = text => {
  return text
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim()
    .replace(/\s+/g, '-')
    .replace(/[^\w-]+/g, '')
    .replace(/--+/g, '-')
}

// Upload image
const uploadImage = async file => {
  try {
    const form = new FormData()
    form.append('image', file)
    const response = await axios.post('uploads/images', form, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    const { data } = response
    return data
  } catch (error) {
    return Promise.reject(error)
  }
}

export {
  createUniqueId,
  registerVuexModule,
  parseErrorResponseToArray,
  checkIfUserIsOwnerOfEntity,
  checkIfUserCanPublishOnGroup,
  slugify,
  uploadImage,
  getCEPData,
  getYoutubeSrcIDFromLink,
  resolvePostUrl
}
